module.exports = "<div light-gallery=\"{images: items, index: index}\"></div>";